<template>
    <v-row no-gutters align="center" class="px-16 py-8 py-lg-16" style="max-height:64px !important">
        <v-col cols="auto" style="width:72px"> </v-col>
        <v-col cols="">
            <head-tabs v-bind="{ value, contract }" class="my-n8" @input="(value) => $emit('input', value)" />
        </v-col>
        <v-col cols="auto" class="d-flex justify-end align-center" style="width:72px">
            <v-btn-toggle borderless v-if="shows_zoom" class="my-n8">
                <v-btn v-bind="{ disabled: disabled_decrease }" small text icon @click="decreaseZoom">
                    <v-icon>mdi-minus</v-icon>
                </v-btn>
                <v-btn v-bind="{ disabled: disabled_increase }" small text icon @click="increaseZoom">
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </v-btn-toggle>
        </v-col>
    </v-row>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { initEmploymentContract } from "@/assets/variables";

import { TABS } from "./lib";

import HeadTabs from "./head/head-tabs.vue";

export default {
    components: {
        HeadTabs,
    },
    props: {
        value: { type: String, default: TABS.VIEW.value },

        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentContract>} */
        contract: { type: Object, default: initEmploymentContract },
    },
    computed: {
        ...mapGetters("employment/form/page", ["disabled_decrease", "disabled_increase"]),
        shows_zoom() {
            switch (this.value) {
                case TABS.VIEW.value:
                case TABS.FORM.value: {
                    return true;
                }

                default: {
                    return false;
                }
            }
        },
    },
    methods: {
        ...mapMutations("employment/form/page", ["decreaseZoom", "increaseZoom"]),
    },
};
</script>

<style></style>
